module.exports = __webpack_public_path__ + "img/标题icon_7.64bfc6f4.png";